import type { RulesetScope, StepRulesetScope } from "./types";
import { RULESET_SCOPES } from "./types";

const rulesetScopeValues = new Set<string>(Object.values(RULESET_SCOPES));

/**
 * Type guard: narrows an unvalidated scope — one read back off a stored agent invocation log,
 * say — to a known `RulesetScope`. Derived from RULESET_SCOPES itself, so a scope added on the
 * Ruby side flows through shared constants without a second list to keep in step.
 */
export const isRulesetScope = (scope: string | null | undefined): scope is RulesetScope => {
  return scope != null && rulesetScopeValues.has(scope);
};

/**
 * The canonical list of scopes evaluated per canvas step, as a readonly tuple
 * so consumers needing a non-empty scope list (e.g. Operator tool schemas) can
 * use it without casting. Adding a step scope here updates the `isStepRulesetScope`
 * slicing and every consumer together.
 */
export const STEP_RULESET_SCOPES = [
  RULESET_SCOPES.MESSAGE_STEP,
  RULESET_SCOPES.AUDIENCE_PATHS_STEP,
] as const satisfies readonly StepRulesetScope[];

const STEP_RULESET_SCOPE_VALUES = new Set<string>(STEP_RULESET_SCOPES);

/**
 * Type guard: returns true when `scope` is evaluated per canvas step (a
 * `StepRulesetScope`) rather than once per Canvas.
 */
export const isStepRulesetScope = (scope: string | undefined): scope is StepRulesetScope => {
  return scope !== undefined && STEP_RULESET_SCOPE_VALUES.has(scope);
};
